import axios from 'axios'
import {ResponseCRUD, ResponseObjectPaginated, ResponseObject} from '../model'
import {EmailTemplateModel} from '../model/emailtemplate.model'
import {TableViewModel} from '../model/tableview.model'

const BASEURL = process.env.REACT_APP_DEV_API_CENTRAL_URL

// INICIO ---- SERVICIOS CRUD
export function getEmailTemplate(dto: EmailTemplateModel, page: number) {
  return axios.post<ResponseObjectPaginated<EmailTemplateModel[]>>(
    `${BASEURL}/email/getAll/${page}`,
    dto,
  )
}

export function getEmailTemplateById(dto: string | undefined) {
  return axios.get<ResponseObject<EmailTemplateModel>>(
    `${BASEURL}/email/getInformationById?EmailId=${dto}`,
  )
}

export function createEmailTemplate(dto: EmailTemplateModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/email/createEmail`, dto)
}

export function deleteEmailTemplate(dto: any) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/email/deleteEmail?id=${dto}`)
}

export function updateEmailTemplate(dto: EmailTemplateModel) {
  return axios.put<ResponseCRUD>(`${BASEURL}/email/updateEmail`, dto)
}

// FIN ---- SERVICIOS CRUD
export function getTablesViews() {
  return axios.get<TableViewModel[]>(`${BASEURL}/email/getTablesViews`)
}
// INICIO ---- SERVICIOS COMBOBOX

//FIN ---- SERVICIOS COMBOBOX
